import React, { useMemo, useCallback } from 'react';
import AdbFlatTableBase, { AdbServiceParams } from './AdbFlatTableBase';
import { fetchClusterDetails } from 'service/service';
import {
  getClusterDetailsColumns,
  CLUSTER_DETAILS_DEFAULT_COLUMNS,
  CLUSTER_COMPUTE_TYPE_OPTIONS,
  QueryRule
} from 'utils/adb-common-util';

const PRESERVE_FILTER_KEY = 'top_ten_cluster_cost_job_table';

/**
 * TopTenClusterCostJob component refactored to use AdbFlatTableBase.
 * Reduces duplication to 0% by leveraging the base component.
 */
const TopTenClusterCostJob: React.FC = () => {
  const serviceFunc = useCallback(async (params: AdbServiceParams) => {
    const {
      startDate, endDate, env, sector, location,
      page, pageSize, apiFilters, exportType,
      sortBy, sortDir
    } = params;
    const findFilter = (field: string) => apiFilters.find(f => f.field === field)?.value;

    const computeType = findFilter('Compute Type') || 'All';
    const jobName = findFilter('Job Name') || 'all';

    return fetchClusterDetails({
      startDate,
      endDate,
      sector,
      env,
      computeType: String(computeType),
      location,
      autoTermination: undefined,
      workspaceID: undefined,
      jobName: String(jobName),
      clusterName: undefined,
      page,
      pageSize,
      sortField: sortBy,
      sortOrder: sortDir,
      exportType
    });
  }, []);

  const initialFilters: QueryRule[] = useMemo(() => [
    { id: '1', operator: 'AND', field: 'Compute Type', value: 'All' },
    { id: '2', operator: 'AND', field: 'Job Name', value: 'all' }
  ], []);

  const environmentOptions = useMemo(() =>
    CLUSTER_COMPUTE_TYPE_OPTIONS.filter(opt => opt.value !== 'SQL'),
    []
  );

  return (
    <AdbFlatTableBase
      serviceFunc={serviceFunc}
      pageTitle="Top 10 Cluster Cost by Compute - Job Details"
      breadcrumbLabel="Cluster Analytics"
      breadcrumbPath="/databricksADB/clusteranalytics"
      tableType="top-ten-cluster-cost-job"
      defaultColumnNames={CLUSTER_DETAILS_DEFAULT_COLUMNS}
      getColumns={getClusterDetailsColumns}
      preserveFilterKey={PRESERVE_FILTER_KEY}
      initialComputeType="All"
      initialFilters={initialFilters}
      environmentOptions={environmentOptions}
      isTopTenClusterCostJob={true}
    />
  );
};

export default TopTenClusterCostJob;